<template>
  <v-dialog v-model="dialog" persistent max-width="650px">
    <v-card>
      <v-card-title>
        <span class="headline">{{
            item ? `Edit News` : 'Create News' }}
        </span>
        <v-switch
                v-model="itemStatus"
                class="mr-2 toggle"
                @change="handleStatusChange(item)"
                :title="item && item.status === 'active' ? 'Switch to inactive' : 'Switch to active'"
        ></v-switch>
        <v-spacer></v-spacer>
        <v-icon @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row class="w-75">
            <v-text-field
                    v-model="formData.headline"
                    label="Headline"
                    placeholder="The news headline(be descriptive)"
                    persistent-placeholder
                    required
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
                    v-model="formData.news"
                    label="News"
                    placeholder="The content of the news Can include embedded HTML(image, link, formatting)"
                    persistent-placeholder
                    required
            ></v-text-field>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="handleCreateOrUpdateNews()" :disabled="!isFormValid">
          {{ isEdit ? 'UPDATE NEWS' : 'CREATE NEWS' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    item: {},
    value: Boolean,
  },
  data() {
    return {
      dialog: this.value,
      isEdit: false,
      availableId: null,
      itemStatus: false,
      formData: {
        id: 0,
        news: "",
        headline: "",
        status: "active",
        isEdit: false
      },
    };
  },
  computed: {
    isFormValid() {
      return this.formData.news && this.formData.headline;
    },
  },
  methods: {
    handleCreateOrUpdateNews() {
      this.formData.status = this.itemStatus ? 'active' : 'inactive';
      this.$emit('createOrUpdateNews', this.formData);
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
      this.formData = {
        id: 0,
        news: '',
        headline: '',
        status: 'active',
      };
      this.$emit('close');
    },
    handleStatusChange(item) {

    },
  },
  async mounted() {
    if (this.item) {
      this.isEdit = true;
      this.itemStatus = this.item.status === 'active';
      this.formData.isEdit = true;
      this.formData = {
        id: this.item.id,
        news: this.item.news,
        headline: this.item.headline,
        status: this.item.status,
        isEdit: true,
      };
    }
  },
};
</script>

<style lang="sass" scoped>
  .toggle
    margin-left: 2% !important

</style>
